import React from 'react';
import { MonetizationOn } from '@material-ui/icons';
import { GridCellParams } from '@material-ui/data-grid';

const CustomGridCellMoneyIcon = (params: GridCellParams) => {
  return <>{params.value === 1 ? <MonetizationOn color='primary' /> : ''}</>;
};

export default CustomGridCellMoneyIcon;
